export interface IHelpGuideModal {
  open: boolean;
  onClose: () => void;
}

export enum HelpGuideTabEnum {
  CONTROLS = 'controls',
  HOTKEYS = 'hotkeys',
  POINTS_OF_INTEREST = 'pointsOfInterest',
  ASSISTANCE = 'assistance',
}
